import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { DefaultHeaderInterceptor } from './default-header.interceptor';
import { ApiPrefixInterceptor } from './api-prefix.interceptor';
import { RequestCacheService } from '../services/request-cache.service';
import { CacheInterceptor } from './cache.interceptor';


export const ProvidersInterceptor = [
  RequestCacheService,
  { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: DefaultHeaderInterceptor, multi: true }
];
